module.exports = __webpack_public_path__ + "assets/img/IMG035.d99fdb5d.png";